// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-system-layout.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-system-layout/fuel-system-layout.js';

mount([g0]);
